import React from "react";
import { Pagination } from "react-bootstrap";

import * as S from "./styles";
import { IProps } from "./types";
import { getDBIdFromGraphqlId, getGraphqlIdFromDBId } from "@utils";

const OffsetPagination: React.FC<IProps> = (
  {
    itemsToShow,
    pagesToShow=6,
    startCursor,
    totalCount,
    setVariables
  }
  : IProps) => {
  const firstReviewIndex = startCursor ? getDBIdFromGraphqlId(startCursor) : 0;
  const currentPage = firstReviewIndex / itemsToShow + 1;

  let items: JSX.Element[] = [];
  const totalPage = Math.ceil(totalCount / itemsToShow);
  const halfPage = Math.floor(pagesToShow / 2);
  const firstPage = Math.max(currentPage - halfPage, 1);
  const prevPage = Math.max(firstPage - halfPage, 1);
  const lastPage = Math.min(firstPage + pagesToShow - 1, totalPage);
  const nextPage = Math.min(lastPage + halfPage, totalPage);

  items.push(<Pagination.First data-page-number={1} key={items.length}/>)
  if (prevPage !== firstPage) items.push(
    <Pagination.Ellipsis data-page-number={prevPage} key={items.length}/>
  );
  for (let i = firstPage; i < lastPage + 1; i++) {
    items.push(
      <Pagination.Item
        data-page-number={i}
        key={items.length}
        active={i === currentPage}>
        {i}
      </Pagination.Item>
    );
  }
  if (nextPage !== lastPage) items.push(
    <Pagination.Ellipsis data-page-number={nextPage} key={items.length}/>
  );
  items.push(<Pagination.Last data-page-number={totalPage} key={items.length}/>)

  const handleClickPageNumber = (e: any) => {
    let target = e.target;
    const tagName = target.tagName;
    if (tagName === 'SPAN') {
      target = e.target.parentElement;
    }
    const pageNumber = target.getAttribute('data-page-number');
    const lastReviewIndex = itemsToShow * (pageNumber - 1) - 1;
    const cursor = getGraphqlIdFromDBId(lastReviewIndex.toString(), 'arrayconnection');
    setVariables((prev: any) => {
      return {...prev, after: cursor}
    })
  }

  return (
    <S.Wrapper>
      {
        !!totalPage &&
        <>
          <style>
            {
              `
                .page-link { color: #fd346a; }
                .page-item.active .page-link { background-color: #fd346a; border-color: #fd346a; }
              `
            }
          </style>
          <Pagination size="sm" onClick={handleClickPageNumber}>{items}</Pagination>
        </>
      }
    </S.Wrapper>
  )
};

export { OffsetPagination }